import { useEffect, useReducer } from "react";
import type { C1_State } from "../types/C1_ModelTypes";

export function useModel(model: C1_State) {
  const [, redraw] = useReducer((value) => value + 1, 0);
  useEffect(() => {
    const handle = model.onChange.subscribe(() => redraw());
    return () => model.onChange.unsubscribe(handle);
  }, [model]);
}
